<form #myForm="ngForm" (ngSubmit)="_onSubmit(myForm.form)">
	<h4 class="font-bold text-lg mb-4">{{ label }}</h4>
	<div class="flex flex-col">
		<app-container type="dark" [testHook]="testHooks.Container">
			<div class="flex flex-col">
				<div [ngClass]="{ flex: !minify, 'flex-col': minify }">
					<app-dropdown
						*ngIf="!minify"
						label="Title"
						[ngClass]="{ 'mt-4': minify }"
						[disabled]="false"
						[itemGroups]="titleOptions"
						[submitted]="myForm.submitted"
						[ngModel]="title"
						name="title"
						(onSelect)="setTitle($event)"
						[testHook]="testHooks.TitleDropdown"
					></app-dropdown>
					<app-input
						[ngClass]="{ 'ml-3': !minify }"
						label="First name"
						name="labels.FIRST_NAME"
						type="text"
						[required]="true"
						[submitted]="myForm.submitted"
						[(ngModel)]="_firstName"
						[testHook]="testHooks.FirstName"
					></app-input>
					<app-input
						[ngClass]="{ 'ml-3': !minify, 'mt-4': minify }"
						label="Last name"
						name="labels.LAST_NAME"
						type="text"
						[required]="true"
						[submitted]="myForm.submitted"
						[(ngModel)]="_lastName"
						[testHook]="testHooks.LastName"
					></app-input>
				</div>
				<div class="flex items-start mt-4" *ngIf="!minify">
					<app-radio-group
						label="Gender"
						[items]="genderOptions"
						class="flex"
						[(ngModel)]="gender"
						name="gender"
						type="compact"
						[testHook]="testHooks.GenderRadioGroup"
					></app-radio-group>
				</div>
				<div class="flex justify-between mt-6" *ngIf="!minify">
					<h5 class="font-bold">Contact details</h5>
					<app-checkbox
						type="clear"
						[label]="checkboxLabel"
						(ngModel)="setAddress($event)"
						[testHook]="testHooks.LabelCheckbox"
					></app-checkbox>
				</div>
				<div class="flex justify-between mt-4">
					<app-input
						*ngIf="!minify"
						label="Work phone"
						name="labels.WORK_PHONE"
						type="tel"
						[(ngModel)]="_workPhone"
						[testHook]="testHooks.WorkPhone"
					></app-input>
					<app-input
						label="Phone number"
						name="labels.PHONE_NUMBER"
						type="tel"
						[(ngModel)]="_phoneNumber"
						[testHook]="testHooks.CellPhone"
					></app-input>
				</div>
				<div class="flex justify-between mt-4">
					<app-input
						*ngIf="!minify"
						label="Fax"
						name="labels.FAX"
						type="tel"
						[(ngModel)]="_fax"
						[testHook]="testHooks.Fax"
					></app-input>
					<app-input
						[ngClass]="{ 'ml-3': !minify }"
						label="Email"
						name="labels.EMAIL"
						type="email"
						[email]="true"
						[(ngModel)]="_email"
						[testHook]="testHooks.Email"
					></app-input>
				</div>
			</div>
		</app-container>

		<div class="flex justify-between mt-4">
			<app-button
				type="button"
				btn="secondary"
				size="small"
				(click)="_onCancel()"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<app-button
				type="submit"
				size="small"
				[loading]="loading"
				[testHook]="testHooks.Button"
			>
				<span *ngIf="_id; else create" [disabled]="myForm.pristine">
					Save
				</span>
				<ng-template #create> Create </ng-template>
			</app-button>
		</div>
	</div>
</form>
